export { DepartmentModal } from './department-modal';
